import { Mountain, Timer, Route, Gauge } from 'lucide-react';

function formatTime(seconds) {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}

function formatDistance(meters) {
  if (meters < 1000) return `${Math.round(meters)} m`;
  return `${(meters / 1000).toFixed(2)} km`;
}

export default function TrackRecordPanel({
  elapsedTime,
  totalDistance,
  altitude,
  speed,
  isPaused,
}) {
  return (
    <div
      className="fixed top-4 left-4 right-4 z-[1000] glass-panel rounded-2xl px-4 py-3 animate-slide-up"
      data-testid="track-record-panel"
    >
      <div className="flex items-center justify-between gap-3">
        <StatItem
          icon={<Timer size={14} strokeWidth={1.5} />}
          value={formatTime(elapsedTime)}
          label="TIME"
          testId="stat-time"
        />
        <StatItem
          icon={<Route size={14} strokeWidth={1.5} />}
          value={formatDistance(totalDistance)}
          label="DIST"
          testId="stat-distance"
        />
        <StatItem
          icon={<Mountain size={14} strokeWidth={1.5} />}
          value={altitude != null ? `${Math.round(altitude)} m` : '--'}
          label="ALT"
          testId="stat-altitude"
        />
        <StatItem
          icon={<Gauge size={14} strokeWidth={1.5} />}
          value={speed != null ? `${(speed * 3.6).toFixed(1)}` : '--'}
          label="KM/H"
          testId="stat-speed"
        />
        {isPaused && (
          <span className="text-xs font-semibold text-yellow-400 tracking-wider uppercase" data-testid="paused-indicator">
            PAUSED
          </span>
        )}
      </div>
    </div>
  );
}

function StatItem({ icon, value, label, testId }) {
  return (
    <div className="flex flex-col items-center gap-0.5" data-testid={testId}>
      <div className="flex items-center gap-1 text-zinc-400">
        {icon}
        <span className="text-[10px] tracking-widest font-medium uppercase">{label}</span>
      </div>
      <span className="text-sm font-bold text-white font-mono tracking-tight">{value}</span>
    </div>
  );
}
